import { render, staticRenderFns } from "./modify_account.vue?vue&type=template&id=4c54d7ea&scoped=true"
import script from "./modify_account.vue?vue&type=script&lang=ts"
export * from "./modify_account.vue?vue&type=script&lang=ts"
import style0 from "./modify_account.vue?vue&type=style&index=0&id=4c54d7ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c54d7ea",
  null
  
)

export default component.exports